module.exports = __webpack_public_path__ + "static/media/artribune.35950418.png";